import { Flex } from "@chakra-ui/react";
import SelectableButton from "components/Button/SelectableButton";
import colors from "core/resources/theme/colors";
import { RelatorioReceitasQueryParams } from "core/features/relatorios/typings/index";

interface TagStatusFiltroRelatoriosReceitaProps {
  onChangeFiltro: (newValues: Partial<RelatorioReceitasQueryParams>) => void;
  filtro: RelatorioReceitasQueryParams;
}

export default function TagStatusFiltroRelatoriosReceita({
  filtro,
  onChangeFiltro,
}: TagStatusFiltroRelatoriosReceitaProps) {
  const onUnselectConciliado = () => onChangeFiltro({ emAberto: undefined });
  const onUnselectNaoConciliado = () =>
    onChangeFiltro({ liquidado: undefined });
  return (
    <Flex gridGap="16px">
      <SelectableButton
        selected={filtro.emAberto === true}
        onClick={() => {
          onChangeFiltro({
            emAberto: true,
          });
          onUnselectNaoConciliado();
        }}
        onUnselect={onUnselectConciliado}
        rounded="full"
        selectedColor={colors.green500}
        fontSize="14px"
      >
        Em aberto
      </SelectableButton>
      <SelectableButton
        selected={filtro.liquidado === true}
        onClick={() => {
          onChangeFiltro({
            liquidado: true,
          });
          onUnselectConciliado();
        }}
        onUnselect={onUnselectNaoConciliado}
        rounded="full"
        selectedColor={colors.yellow}
        fontSize="14px"
      >
        Liquidadas
      </SelectableButton>
    </Flex>
  );
}
